import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
    ExchangeRate, ExchangeRateImportResult, ExchangeRateRequest, LatestRate,
} from '../interfaces/fx.interface';

export interface ExchangeRatePage {
    content: ExchangeRate[];
    totalElements: number;
}

export const ExchangeRateService = {
    list: async (institutionId: string, params: { currency?: string; from?: string; to?: string; page?: number; size?: number }): Promise<ExchangeRatePage> =>
        (await axios.get(ENDPOINTS.EXCHANGE_RATE.LIST(institutionId), { params })).data,
    /** The rate in force on `asOf` (latest on or before it). 404 when none exists. */
    latest: async (institutionId: string, currency: string, asOf?: string): Promise<LatestRate> =>
        (await axios.get(ENDPOINTS.EXCHANGE_RATE.LATEST(institutionId), { params: { currency, asOf } })).data,
    create: async (institutionId: string, req: ExchangeRateRequest): Promise<ExchangeRate> =>
        (await axios.post(ENDPOINTS.EXCHANGE_RATE.LIST(institutionId), req)).data,
    update: async (institutionId: string, id: string, req: ExchangeRateRequest): Promise<ExchangeRate> =>
        (await axios.put(ENDPOINTS.EXCHANGE_RATE.ITEM(institutionId, id), req)).data,
    remove: async (institutionId: string, id: string): Promise<void> => {
        await axios.delete(ENDPOINTS.EXCHANGE_RATE.ITEM(institutionId, id));
    },
    importCsv: async (institutionId: string, csv: string): Promise<ExchangeRateImportResult> =>
        (await axios.post(ENDPOINTS.EXCHANGE_RATE.IMPORT(institutionId), { csv })).data,
};
